<template>
     <section id="hero" class="hero section dark-background">
      <img src="../../lands/assets/img/hero-bg-2.jpg" alt="" class="hero-bg">

      <div class="container">
        <div class="row gy-4 justify-content-between">
          <div class="col-lg-4 order-lg-last hero-img">
            <img src="../../lands/assets/img/hero-img.png" class="img-fluid animated" alt="">
          </div>

          <div class="col-lg-6  d-flex flex-column justify-content-center">
            <h1>Payez vos droits de place en toute <span>Sécurité</span></h1>
            <p>Nous sommes disponible pour vous 24h/24</p>
            <div class="d-flex">
              <router-link to="/e-processus" class="btn-get-started">Payer</router-link>
              <a href="https://www.youtube.com/watch?v=IYVbN__C8YA" class="glightbox btn-watch-video d-flex align-items-center"><i class="bi bi-play-circle"></i><span>Vidéo</span></a>
            </div>
          </div>
        </div>
      </div>

      <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
          <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
        </defs>
        <g class="wave1">
          <use xlink:href="#wave-path" x="50" y="3"></use>
        </g>
        <g class="wave2">
          <use xlink:href="#wave-path" x="50" y="0"></use>
        </g>
        <g class="wave3">
          <use xlink:href="#wave-path" x="50" y="9"></use>
        </g>
      </svg>

    </section>
</template>
<script lang="ts">
	import { defineComponent,onMounted } from "vue";

	export default defineComponent({
		name: "SectionOne",
		components: {},
		setup() {
			//
		}		
	});
</script>